







































import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../../../shared/services/mixin";
import {Component, Prop, PropSync} from "vue-property-decorator";
import {DebtCustomer, DebtPostOffice} from "@/interfaces/entity";
import LadingStatusLabel from "@/shared/components/LadingStatusLabel/index.vue";
import LadingPaymentTypeLabel from "../../../../../ladings/List/components/PaymentTypeLabel.vue";
import {ClearingDebtType} from "@/enums/type";


@Component({
    name: "ReceiptDebtCustomerTable",
    components: {LadingPaymentTypeLabel, LadingStatusLabel}
})
export default class extends mixins(CommonMixin) {
    @Prop() readonly debtCustomers!: Array<DebtCustomer>;
    @PropSync('debtIds', {default: () => [], type: Array}) syncDebtIds!: number[];

    startRowIndex = 0

    columns = [
        {
            field: "",
            type: "checkbox",
            key: "b",
            title: "",
            align: "center",
            width: 5,
        },
        {
            field: "",
            key: "a",
            title: "STT",
            align: "left",
            renderBodyCell: this.renderRowIndex,
            width: 10
        },
        {
            field: "",
            key: "dateOfAcceptance",
            title: "Ngày phát hành",
            width: 150,
            align: "left",
            renderBodyCell: ({row, column, rowIndex}, h) => {
                return this.getDateTimeFromMls(row.billLading.dateOfAcceptance);
            },
        },
        {
            field: "",
            key: "ladingCode",
            title: "Mã vận đơn",
            width: 150,
            align: "left",
            renderBodyCell: ({row, column, rowIndex}, h) => {
                return row.billLading.ladingCode;
            },
        },
        {
            field: "",
            key: "money",
            title: "Tổng thu",
            width: 150,
            align: "left",
            renderBodyCell: ({row, column, rowIndex}, h) => {
                if (row.clearingType === this.clearingType.Yes) return row.clearingMoney ? row.clearingMoney.toLocaleString('en-US') + 'đ' : 0
                else return row.money ? row.money.toLocaleString('en-US') + 'đ' : 0
            },
        }
    ]
    clearingType = ClearingDebtType

    onSelectedIdsChange(selectedIds: any) {
        this.syncDebtIds = selectedIds;
    }

    virtualScrollOption = {
        enable: true,
        scrolling: this.scrolling,
    }

    checkboxOption = {
        selectedRowChange: ({row, isSelected, selectedRowKeys}) => {
            console.log(this, selectedRowKeys)
            this.changeSelectedRowKeys(selectedRowKeys);
        },
        selectedAllChange: ({isSelected, selectedRowKeys}) => {
            console.log(selectedRowKeys)
            this.changeSelectedRowKeys(selectedRowKeys);
        },
    }

    scrolling({
                  startRowIndex,
                  visibleStartIndex,
                  visibleEndIndex,
                  visibleAboveCount,
                  visibleBelowCount,
              }) {
        this.startRowIndex = startRowIndex;
        console.log(this.syncDebtIds)
    }

    renderRowIndex({row, column, rowIndex}) {
        return rowIndex + this.startRowIndex + 1
    }

    changeSelectedRowKeys(keys) {
        this.syncDebtIds = keys;
    }
}
